import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.flags";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This is the top level view which the entire app is rendered in to
 */
import PropTypes from 'prop-types';
import React, { Component, Fragment, StrictMode } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { defineMessages, intlShape, injectIntl } from 'react-intl';
import { hot } from 'react-hot-loader/root';
import * as cookiePolicyHelper from 'helpers/cookiePolicyHelper';
import * as userTypeCookie from 'helpers/userTypeCookie';
import * as utmValues from 'helpers/utmValues';
import { deepExtract } from 'helpers/deep';
import { CookieBanner } from 'components/Banner/Banners/CookieBanner';
import { DisclaimerModal } from 'components/DisclaimerModal/DisclaimerModal';
import { FooterContainer } from 'components/Footer/Footer';
import { FullScreenError } from 'components/Errors/FullScreenError';
import { RetainSDK } from 'components/RetainSDK/RetainSDK';
import { FullStorySDK } from 'components/FullStorySDK/FullStorySDK';
import { GoogleAnalytics } from 'components/GoogleAnalytics/GoogleAnalytics';
import { GoogleTagManager } from 'components/GoogleTagManager/GoogleTagManager';
import { MediaListener } from 'components/MediaListener';
import { MixPanel } from 'components/MixPanel/MixPanel';
import { ModalHost } from 'components/ModalHost/ModalHost';
import { SnowplowTracker } from 'components/SnowplowTracker/SnowplowTracker';
import { withSagas } from 'decorators/Sagas/Sagas';
import { OptimizelySDK } from 'vendors/Optimizely/OptimizelySDK';
import clientConfig from 'universal-config';
import { decorateWith, withName } from 'helpers/decorator';
import isMobile, { isWebview } from 'helpers/isMobile';
import { glsLocation, userProfile } from 'redux/saga/entities/bound';
import { flush as flushStats } from 'helpers/statsd';
import { toggleFlag } from 'redux/modules/page';
import { setIsClient } from 'redux/modules/device';
import { selectUserLocation } from 'redux/modules/locale';
import { BannerHost } from 'features/Banners/BannerHost';
import { watchAnnouncements, loadAnnouncements } from 'containers/Announcements/announcements.saga';
import { AppHeaderContainer } from 'components/AppHeader/AppHeader';
import { loadInitialApp, watchLoadInitialApp, watchReservationStatusChanged } from './app.saga';
import { showReferAFriendBanner, watchReferAFriendBanner } from './app-refer-a-friend.saga';

require('../../styles/main.scss');

export var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ref = selectUserLocation(state) || {},
      lat = _ref.lat,
      lon = _ref.lon;

  var userLocation = glsLocation.data(state, "".concat(lat, "_").concat(lon)) || {};
  var glsLocationId = deepExtract('location.id', userLocation, undefined);
  return {
    config: clientConfig(),
    continent: state.locale.continent,
    currentFullUrl: state.request.currentFullUrl,
    currentRouterPath: ownProps.location.pathname + (ownProps.location.search || ''),
    deviceType: state.request.deviceType,
    error: state.error,
    flags: state.page.flags,
    glsLocationId: glsLocationId,
    query: state.request.query,
    userProfile: userProfile.data(state),
    visitorId: state.request.visitorId
  };
};
export var mapDispatchToProps = {
  loadInitialApp: loadInitialApp,
  loadAnnouncements: loadAnnouncements,
  showReferAFriendBanner: showReferAFriendBanner,
  toggleFlag: toggleFlag,
  setIsClient: setIsClient
};
var messages = defineMessages({
  description: {
    id: 'App.description',
    defaultMessage: 'Work out at the best studios in your city'
  },
  ogTitle: {
    id: 'App.ogTitle',
    defaultMessage: 'ClassPass - Work out at the best studios in your city'
  },
  ogSite_name: {
    id: 'App.ogSite_name',
    defaultMessage: 'ClassPass'
  }
});
export var AppUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(AppUnwrapped, _Component);

  function AppUnwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AppUnwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AppUnwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleDocumentClick", function () {
      var _this$props = _this.props,
          flags = _this$props.flags,
          localToggleFlag = _this$props.toggleFlag;

      if (isMobile() && flags.headerAccountDropdownOpen) {
        localToggleFlag('headerAccountDropdownOpen');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "shouldShowCookiePolicy", function () {
      var _this$props2 = _this.props,
          continent = _this$props2.continent,
          flags = _this$props2.flags,
          location = _this$props2.location;
      return __CLIENT__ && continent === 'europe' && !_this.hasSeenCookiePolicy && flags.showCookiePolicy && !isWebview(location.search);
    });

    _defineProperty(_assertThisInitialized(_this), "showAnnouncements", function () {
      var localLoadAnnouncements = _this.props.loadAnnouncements;
      localLoadAnnouncements();
    });

    _this.hasSeenCookiePolicy = cookiePolicyHelper.hasSeenCookiePolicy();
    return _this;
  }

  _createClass(AppUnwrapped, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.loadInitialApp();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          currentRouterPath = _this$props3.currentRouterPath,
          localUserProfile = _this$props3.userProfile,
          localSetIsClient = _this$props3.setIsClient,
          localShowReferAFriendBanner = _this$props3.showReferAFriendBanner;
      utmValues.save(currentRouterPath);
      userTypeCookie.setFromProfile(localUserProfile);
      window.addEventListener('unload', flushStats);

      if (__CLIENT__ && !this.hasSeenCookiePolicy) {
        cookiePolicyHelper.set(true);
      }

      localShowReferAFriendBanner();
      this.showAnnouncements();
      localSetIsClient(true);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props4 = this.props,
          currentRouterPath = _this$props4.currentRouterPath,
          localUserProfile = _this$props4.userProfile;

      if (__CLIENT__) {
        if (nextProps.currentRouterPath !== currentRouterPath) {
          window.scrollTo(0, 0);
        }

        if (!localUserProfile && nextProps.userProfile) {
          userTypeCookie.setFromProfile(nextProps.userProfile);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          config = _this$props5.config,
          currentFullUrl = _this$props5.currentFullUrl,
          currentRouterPath = _this$props5.currentRouterPath,
          deviceType = _this$props5.deviceType,
          error = _this$props5.error,
          glsLocationId = _this$props5.glsLocationId,
          query = _this$props5.query,
          routes = _this$props5.routes,
          localToggleFlag = _this$props5.toggleFlag,
          localUserProfile = _this$props5.userProfile,
          visitorId = _this$props5.visitorId,
          intl = _this$props5.intl;
      var app = React.createElement(Fragment, null, React.createElement(MediaListener, null), React.createElement(Helmet, null, React.createElement("meta", {
        charSet: "utf-8"
      }), React.createElement("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
      }), React.createElement("meta", {
        name: "description",
        content: intl.formatMessage(messages.description)
      }), React.createElement("meta", {
        property: "og:title",
        content: intl.formatMessage(messages.ogTitle)
      }), React.createElement("meta", {
        property: "og:url",
        content: currentFullUrl
      }), React.createElement("meta", {
        property: "og:type",
        content: "website"
      }), React.createElement("meta", {
        property: "og:site_name",
        content: intl.formatMessage(messages.ogSite_name)
      }), React.createElement("meta", {
        property: "og:image",
        content: require('../../../static/img/facebook-image-yoga.jpg')
      }), React.createElement("meta", {
        property: "fb:app_id",
        content: deepExtract('fb.appId', config)
      }), React.createElement("meta", {
        property: "p:domain_verify",
        content: "ed77031fc6389d9c85c24dd3a1cad7d5"
      }), React.createElement("meta", {
        property: "apple-mobile-web-app-capable",
        content: "yes"
      }), React.createElement("meta", {
        property: "mobile-web-app-capable",
        content: "yes"
      }), React.createElement("link", {
        rel: "shortcut icon",
        content: "/favicon.ico"
      }), React.createElement("link", {
        rel: "dns-prefetch",
        content: "//hello.myfonts.net"
      })), React.createElement(ModalHost, null), React.createElement(BannerHost, {
        category: "announcement"
      }), React.createElement(AppHeaderContainer, null), React.createElement(BannerHost, {
        category: "notification"
      }), React.createElement("div", {
        className: "body__content"
      }, error ? React.createElement(FullScreenError, {
        error: error
      }) : children, this.shouldShowCookiePolicy() && React.createElement(DisclaimerModal, {
        onClose: localToggleFlag.bind(this, 'showCookiePolicy'),
        text: React.createElement(CookieBanner, null)
      })), React.createElement(FooterContainer, null));

      if (query.disableTrackers) {
        return app;
      }

      return React.createElement(StrictMode, null, React.createElement(SnowplowTracker, {
        host: config.snowplow.host,
        appId: config.snowplow.appId
      }), app, React.createElement(GoogleAnalytics, {
        userId: localUserProfile && localUserProfile.id,
        currentPath: currentRouterPath,
        accountKey: config.googleAnalytics.key,
        cookieDomain: config.googleAnalytics.cookieDomain
      }), React.createElement(MixPanel, {
        currentUser: localUserProfile,
        routes: routes,
        msa: localUserProfile && localUserProfile.msa,
        accountKey: config.mixpanel.key,
        deviceType: deviceType,
        currentPath: currentRouterPath
      }), React.createElement(GoogleTagManager, {
        userId: localUserProfile && localUserProfile.id,
        containerId: config.googleTagManager.container,
        glsLocationId: glsLocationId
      }), React.createElement(FullStorySDK, {
        currentUser: localUserProfile,
        currentPath: currentRouterPath,
        visitorId: visitorId
      }), React.createElement(RetainSDK, {
        currentUser: localUserProfile,
        accountKey: config.retain.appKey
      }), React.createElement(OptimizelySDK, null));
    }
  }]);

  return AppUnwrapped;
}(Component);
AppUnwrapped.contextTypes = {
  store: PropTypes.object.isRequired
};
AppUnwrapped.propTypes = {
  children: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  continent: PropTypes.string.isRequired,
  currentFullUrl: PropTypes.string.isRequired,
  currentRouterPath: PropTypes.string.isRequired,
  deviceType: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
  flags: PropTypes.object.isRequired,
  loadInitialApp: PropTypes.func.isRequired,
  loadAnnouncements: PropTypes.func.isRequired,
  location: PropTypes.object,
  query: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired,
  showReferAFriendBanner: PropTypes.func.isRequired,
  toggleFlag: PropTypes.func.isRequired,
  glsLocationId: PropTypes.number,
  userProfile: PropTypes.object,
  visitorId: PropTypes.string,
  setIsClient: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};
export var App = decorateWith(withSagas({
  watch: [watchLoadInitialApp, watchReferAFriendBanner, watchAnnouncements, watchReservationStatusChanged]
}), connect(mapStateToProps, mapDispatchToProps), injectIntl, hot, withName('App'))(AppUnwrapped);